import { useState, useEffect } from 'react'
import { AppSettingsApi } from '../services'
import { useTheme } from '../contexts'

interface HeaderSettings {
  appTitle: string
  appVersion: string
  headerImageUrl: string | null
  headerFont: string
  headerColor: string
}

export const useHeaderSettings = () => {
  const [headerSettings, setHeaderSettings] = useState<HeaderSettings>({
    appTitle: 'Parallo Quoter',
    appVersion: '0.0.0',
    headerImageUrl: null,
    headerFont: 'Poppins',
    headerColor: '#000000'
  })
  const [loading, setLoading] = useState(true)
  const { isDarkMode } = useTheme()

  useEffect(() => {
    const loadHeaderSettings = async () => {
      try {
        setLoading(true)
        
        // Fetch app title
        let appTitle = 'Parallo Quoter'
        try {
          const titleResponse = await AppSettingsApi.getAppSetting('app_title')
          if (titleResponse.success && titleResponse.data.value) {
            appTitle = titleResponse.data.value
          }
        } catch (error) {
        }

        // Fetch app version
        let appVersion = '0.0.0'
        try {
          const versionResponse = await AppSettingsApi.getAppSetting('app_version')
          if (versionResponse.success && versionResponse.data.value) {
            appVersion = versionResponse.data.value
          }
        } catch (error) {
        }

        // Fetch appropriate header image based on theme
        let headerImageUrl: string | null = null
        const imageKey = isDarkMode ? 'header_image_dark_mode' : 'header_image_light_mode'
        
        try {
          const imageResponse = await AppSettingsApi.getAppSetting(imageKey)
          if (imageResponse.success && imageResponse.data.value) {
            headerImageUrl = imageResponse.data.value
          }
        } catch (error) {
        }

        // Fetch header font
        let headerFont = 'Poppins'
        try {
          const fontResponse = await AppSettingsApi.getAppSetting('header_font')
          if (fontResponse.success && fontResponse.data.value) {
            headerFont = fontResponse.data.value
          }
        } catch (error) {
        }

        // Fetch header color
        let headerColor = '#000000'
        try {
          const colorResponse = await AppSettingsApi.getAppSetting('header_color')
          if (colorResponse.success && colorResponse.data.value) {
            headerColor = colorResponse.data.value
          }
        } catch (error) {
        }

        setHeaderSettings({
          appTitle,
          appVersion,
          headerImageUrl,
          headerFont,
          headerColor
        })
      } catch (error) {
        // Keep default values
      } finally {
        setLoading(false)
      }
    }

    loadHeaderSettings()
  }, [isDarkMode]) // Re-run when theme changes

  return {
    headerSettings,
    loading
  }
}
